<script>
import { Line } from 'vue-chartjs'
export default {
  name: 'AccountActivityChart',
  extends: Line,
  props: ['activity'],
  // props: ['data', 'options'],
  data () {
    return {
      data: {
        labels: this.activity.months,
        datasets: [{
          backgroundColor: 'transparent',
          borderColor: '#c5263b',
          pointBackgroundColor: '#c5263b',
          pointBorderColor: 'white',
          pointHoverBackgroundColor: '#c5263b',
          pointHoverBorderColor: '#c5263b',
          data: this.activity.downloads,
          label: 'No. of Downloads'
        }]
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        hover: {
          mode: 'nearest',
          intersect: true
        },
        legend: {
          display: false
        },
        tooltips: {
          mode: 'index'
        },
        scales: {
          xAxes: [{
            gridLines: [{
              display: false
            }],
            ticks: {
              display: true,
              fontColor: 'grey',
              fontSize: 13,
              padding: 10
            }
          }],
          yAxes: [{
            gridLines: {
              drawBorder: false,
              drawTicks: false,
              borderDash: [3, 4],
              zeroLineWidth: 1,
              zeroLineBorderDash: [3, 4]
            },
            ticks: {
              display: true,
              fontColor: 'grey',
              fontSize: 13,
              padding: 10
            }
          }]
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.data, this.options)
  },
  methods: {
  }
}
</script>

<style scoped>
  canvas#line-chart {
    height: 250px;
  }
</style>



// WEBPACK FOOTER //
// src/components/AccountActivityChart.vue